import React, { useEffect } from "react";
// react-redux
import { useDispatch, useSelector } from "react-redux";
// react-router-dom
import { Link } from "react-router-dom";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// actions
import { fetchRecommendedPosts } from "../../store/actions/WordPressApiAction";
// util
import { getTargetStr } from "../../util/util";
// styles
import styles from "./recommendedPostsStyle";
const useStyles = makeStyles(styles);

export default function RecommendedPosts(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const fetchRecommendedPostsData = useSelector(
    (state) => state.fetchRecommendedPostsReducer
  );
  useEffect(() => {
    dispatch(fetchRecommendedPosts(props.RecommendedPosts));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.RecommendedPosts]);

  return (
    <div className={classes.recommendedPostsContainer}>
      <div className={classes.recommendedPostsHeader}>おすすめの記事</div>
      <List className={classes.recommendedPostsList}>
        {fetchRecommendedPostsData.map((item) => {
          return (
            <Link
              to={getTargetStr(item.link, props.siteURL)}
              className={classes.link}
              key={item.id}
            >
              <ListItem key={item.id} className={classes.listItem}>
                <img
                  src={item._embedded["wp:featuredmedia"][0].source_url}
                  alt="postImage"
                  className={classes.postImg}
                />
              </ListItem>
            </Link>
          );
        })}
      </List>
    </div>
  );
}
